import styled from "styled-components"

const imageCaption = styled.p`
  margin-top: 1rem;
`

export default imageCaption
